import * as React from "react";
const SvgTrendingFlatOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="m22 12-4-4v3H3v2h15v3l4-4z" />
  </svg>
);
export default SvgTrendingFlatOutlined;
